"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnemyResurrectedEventArgs = void 0;
const EventType_1 = require("../EventType");
class EnemyResurrectedEventArgs {
    constructor(enemyId) {
        this.enemyId = enemyId;
        this.__type = EventType_1.EventType.EnemyResurrected;
        this.__typeName = "EnemyResurrected";
    }
}
exports.EnemyResurrectedEventArgs = EnemyResurrectedEventArgs;
